import React from 'react';
import NumSelector from './numSelector';
import './saleConfirm.scss';

class VerifyConfirmInfo extends React.Component{
  render() {
    return (
      <div className='verifyConfirmInfo'>
       { this.props.groupData.ccardNo&&
        <div className='ccard-info'>
          <div className='column-title'>次卡用户信息</div>
          {//如果有用户头像展示实名认证信息，否则展示次卡信息
            this.props.groupData.photo?
            <div className='ccard-certify-info'>
              <img alt='' src={this.props.groupData.photo}></img>
              <div className='detail-info'>
                {this.props.groupData.userMemberName&&
                  <div className='row'>
                    <div className='title'><span className='label-name'>姓名</span><span>:</span></div>
                    <div className='text'>{this.props.groupData.userMemberName}</div>
                  </div>    
                }
                {this.props.groupData.gender&&
                  <div className='row'>
                    <div className='title'><span className='label-name'>性别</span><span>:</span></div>
                    <div className='text'>{this.props.groupData.gender==='1'?'男':'女'}</div>
                  </div>    
                }
                {this.props.groupData.age&&
                  <div className='row'>
                    <div className='title'><span className='label-name'>年龄</span><span>:</span></div>
                    <div className='text'>{this.props.groupData.age}岁</div>
                  </div>    
                }
                {this.props.groupData.cred&&
                  <div className='row'>
                    <div className='title'><span className='label-name'>身份证号</span><span>:</span></div>
                    <div className='text'>{this.props.groupData.cred}</div>
                  </div>    
                }
              </div>
            </div>:
            <div>
            {this.props.groupData.ccardName&&
                <div className='row'>
                  <div className='title'><span className='label-name'>卡名</span><span>:</span></div>
                  <div className='text'>{this.props.groupData.ccardName}</div>
                </div>    
              }
              {this.props.groupData.ccardNo&&
                <div className='row'>
                  <div className='title'><span className='label-name'>卡号</span><span>:</span></div>
                  <div className='text'>{this.props.groupData.ccardNo}</div>
                </div>    
              }
            </div>
          }
        </div>
       }
        <div className='column-title'>活动信息</div>
        {this.props.actTitle &&
          <div className='row'>
            <div className='title'><span className='label-name'>活动</span><span>:</span></div>
            <div className='text'>{this.props.actTitle}</div>
          </div>
        }
        {this.props.groupTitle &&
          <div className='row'>
            <div className='title'><span className='label-name'>套餐</span><span>:</span></div>
            <div className='text cb6'>{this.props.groupTitle}</div>
          </div>
        }
        {this.props.payTime &&
          <div className='row'>
            <div className='title'><span className='label-name'>报名时间</span><span>:</span></div>
            <div className='text cb6'>
              {this.props.payTime}
            </div>
          </div>
        }
        {this.props.verifyTime &&
          <div className='row'>
            <div className='title'><span className='label-name'>打卡时间</span><span>:</span></div>
            <div className='text cb6'>
              {this.props.verifyTime}
              {this.props.verifyTip && <div className='cred'>{this.props.verifyTip}</div>}
            </div>
          </div>
        }
        <NumSelector total={this.props.total} unverifyText={this.props.unverifyText} handleSelect={this.props.handleSelect}/>
      </div>)
  }
}
export default VerifyConfirmInfo;
